import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { productCategories } from '../mock';

// Hand-picked best-sellers across categories
const featuredKeys = [
  { cat: 'bed', idx: 1 },    // VENUS Range
  { cat: 'lou', idx: 11 },   // Icon Lounge
  { cat: 'mat', idx: 2 },    // Luxury Comfort
  { cat: 'tab', idx: 0 },    // VT Walnut 7 Pieces
  { cat: 'war', idx: 5 },    // 3 Doors Mirror
  { cat: 'tv', idx: 0 },     // BET Set
  { cat: 'desk', idx: 1 },   // Hongkong Desk
  { cat: 'lou', idx: 0 },    // VENUS 01 Armchair
];

const FeaturedProducts = () => {
  const items = featuredKeys
    .map(({ cat, idx }) => {
      const list = productCategories[cat]?.products || [];
      const product = list[idx] || list[0];
      return product ? { ...product, cat, slug: productCategories[cat].title } : null;
    })
    .filter(Boolean);

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-white">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="text-xs md:text-sm text-gray-500 mb-3 tracking-[0.3em] uppercase">
              Featured Pieces
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-black tracking-tight font-display-serif">
              Customer favourites
            </h2>
          </div>
          <Link
            to="/furniture"
            className="inline-flex items-center gap-2 text-sm font-medium text-black border-b border-black pb-1 hover:gap-3 transition-all w-fit"
          >
            View all furniture
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((p, idx) => (
            <Link
              key={idx}
              to={`/furniture#${p.cat}`}
              className="group block"
            >
              <div className="aspect-[4/5] bg-[#f7f5f1] rounded-2xl overflow-hidden mb-4 relative">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-4 left-4 right-4 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <span className="inline-flex items-center gap-1 text-xs font-medium bg-white text-black px-3 py-1.5 rounded-full">
                    Enquire <ArrowUpRight className="w-3 h-3" />
                  </span>
                </div>
              </div>
              <div className="px-1">
                <p className="text-xs text-gray-500 mb-1 tracking-wide uppercase">{p.slug}</p>
                <h3 className="text-base md:text-lg font-semibold text-black group-hover:underline underline-offset-2">
                  {p.name}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
